export const activeOptions = <
  T extends { id: string; name?: string | null; is_deleted?: boolean },
>(
  items: T[],
): T[] =>
  items
    .filter((item) => !item.is_deleted)
    .sort(
      (a, b) =>
        (a.name ?? a.id).localeCompare(b.name ?? b.id, 'en', {
          sensitivity: 'base',
        }) || a.id.localeCompare(b.id, 'en'),
    )
